import { render, staticRenderFns } from "./connectwise-manage-page.vue?vue&type=template&id=5b6c9054&scoped=true&"
import script from "./connectwise-manage-page.vue?vue&type=script&lang=tsx&"
export * from "./connectwise-manage-page.vue?vue&type=script&lang=tsx&"
import style0 from "./connectwise-manage-page.vue?vue&type=style&index=0&id=5b6c9054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c9054",
  null
  
)

export default component.exports